import { Fragment, useEffect, useState } from "react";
import { formatCurrency } from "src/utils/FormatCurrency";
import { ProgramSummaryDetailSummaryModel } from "src/models/ProgramSummaryDetailSummaryModel";
import { AmountTotalType } from "src/models/AmountTotalType";

type ProgramSummaryDetailSummaryDataProps = {
  summaryDetail: ProgramSummaryDetailSummaryModel;
};

const ProgramSummaryDetailSummaryData = ({
  summaryDetail,
}: ProgramSummaryDetailSummaryDataProps) => {
  const [summaryData, setSummaryData] =
    useState<ProgramSummaryDetailSummaryModel>(
      {} as ProgramSummaryDetailSummaryModel
    );

  useEffect(() => {
    if (summaryDetail) {
      setSummaryData(summaryDetail);
    }
  }, [summaryDetail]);

  return (
    <div className="">
      <div className="row">
        <div className="col-6 summary-data">
          {summaryData?.amountTypes?.map((t: AmountTotalType, idx: number) => (
            <Fragment key={`amountTotals-${idx}`}>
              <div className="grouping1">
                <div>Funded Amount</div>
                <div>
                  {formatCurrency(t.totalFundedAmount, t.currencyAlphaCode)}
                </div>
              </div>
              <div className="grouping2">
                <div>Property Fees</div>
                <div>
                  {formatCurrency(t.totalPropertyFees, t.currencyAlphaCode)}
                </div>
              </div>
              <div className="grouping3">
                <div>Reloaded Amount</div>
                <div>
                  {formatCurrency(t.totalReloadedAmount, t.currencyAlphaCode)}
                </div>
              </div>
              <div className="grouping3">
                <div>Total Sales</div>
                <div>
                  {formatCurrency(t.totalSalesAmount, t.currencyAlphaCode)}
                </div>
              </div>
            </Fragment>
          ))}
        </div>
        <div className="col-6 summary-data">
          <div className="grouping">
            <div>Total Cards Funded</div>
            <div>{summaryData?.cardsFundedCount}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramSummaryDetailSummaryData;
